var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddrTrans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 31.6579,
    rx: 15,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.0009V11.0109M19 19.0009V19.0109M13.828 13.8289C14.3875 13.2695 14.7686 12.5568 14.9231 11.7808C15.0775 11.0048 14.9984 10.2005 14.6956 9.46955C14.3929 8.73857 13.8802 8.11378 13.2224 7.67421C12.5646 7.23463 11.7912 7 11 7C10.2088 7 9.43542 7.23463 8.7776 7.67421C8.11977 8.11378 7.60708 8.73857 7.30437 9.46955C7.00165 10.2005 6.92251 11.0048 7.07695 11.7808C7.23139 12.5568 7.61247 13.2695 8.172 13.8289L11 16.6579L13.828 13.8289ZM21.828 21.8289C22.3875 21.2695 22.7686 20.5568 22.9231 19.7808C23.0775 19.0048 22.9983 18.2005 22.6956 17.4695C22.3929 16.7386 21.8802 16.1138 21.2224 15.6742C20.5646 15.2346 19.7912 15 19 15C18.2088 15 17.4354 15.2346 16.7776 15.6742C16.1198 16.1138 15.6071 16.7386 15.3044 17.4695C15.0017 18.2005 14.9225 19.0048 15.0769 19.7808C15.2314 20.5568 15.6125 21.2695 16.172 21.8289L19 24.6579L21.828 21.8289Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddrTrans);
export default __webpack_public_path__ + "static/media/icon-addr-trans.74251cc047872f0b777368f6b847d70d.svg";
export { ForwardRef as ReactComponent };